import React from 'react';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import { TextButton } from './common';
import { loadAuth2, loadGapiInsideDOM } from 'gapi-script';
import aws_config from '../../auth/awsConfig';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

// Function to generate a unique color based on the username
function stringToColor(string) {
  // Define a palette of primary and vibrant colors
  const primaryColors = [
    '#2196F3', // Blue
    '#4CAF50', // Green
    '#FF9800', // Orange
    '#F44336', // Red
    '#9C27B0', // Purple
    '#00BCD4', // Cyan
    '#FF5722', // Deep Orange
    '#3F51B5', // Indigo
    '#8BC34A', // Light Green
    '#E91E63', // Pink
    '#795548', // Brown
    '#607D8B', // Blue Grey
    '#FFC107', // Amber
    '#009688', // Teal
    '#673AB7', // Deep Purple
    '#CDDC39', // Lime
  ];

  let hash = 0;
  for (let i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use the hash to select a color from the palette
  const colorIndex = Math.abs(hash) % primaryColors.length;
  return primaryColors[colorIndex];
}

export function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name && name.length > 0 ? name.split(' ')[0][0].toUpperCase() : ''}${
      name && name.split(' ')[1] ? name.split(' ')[1][0].toUpperCase() : ''
    }`,
  };
}

class UserAccount extends React.Component {
  state = {
    showLogout: false,
    username: '',
    openMenu: false,
    anchorEl: null,
    accountStatus: '',
  };

  constructor(props) {
    super(props);
  }

  onSignOut = () => {
    signOut().then(async () => {
      const gapi = await loadGapiInsideDOM();
      await loadAuth2(gapi, aws_config.gg_client_id, '');
      const auth = gapi.auth2;

      auth
        .getAuthInstance()
        .signOut()
        .then(() => {
          console.log('User signed out.');

          window.history.pushState({}, document.title, '/form');
          window.location.pathname = '/form';
        });
    });
  };

  componentDidMount() {
    getCurrentUser()
      .then((user) => {
        if (user) {
          if (user.username.startsWith('Google_')) {
            this.setState({
              accountStatus: 'GOOGLE',
              showLogout: true,
              username: user.signInDetails?.loginId || user.username, // Set username as email if it starts with "Google_"
            });
          } else {
            this.setState({
              accountStatus: 'USERNAME',
              showLogout: true,
              username: user.username,
            });
          }
        }
      })
      .catch(() => console.log('Not signed in'));
  }

  handleClick = (event) => {
    this.setState({ openMenu: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ openMenu: false, anchorEl: null });
  };

  render() {
    if (this.state.showLogout) {
      const avatarColor = stringToColor(this.state.username);
      return (
        <div
          className="account-container"
          style={{ marginLeft: 8, display: 'flex', alignItems: 'center' }}
        >
          <TextButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={this.handleClick}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Avatar
              style={{
                marginRight: 8,
                width: 24,
                height: 24,
                backgroundColor: avatarColor,
                fontSize: '0.75em',
                border: '2px solid #fff',
                fontWeight: 600,
                borderRadius: '6px',
              }}
            >
              {this.state.username.charAt(0).toUpperCase()}
            </Avatar>
            {this.state.username}
          </TextButton>
          <Menu
            open={this.state.openMenu}
            anchorEl={this.state.anchorEl}
            onClose={this.handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <MenuItem onClick={this.onSignOut}>
              <ExitToAppIcon style={{ marginRight: 8 }} /> {/* Add the icon */}
              Log out
            </MenuItem>
          </Menu>
        </div>
      );
    } else {
      return '';
    }
  }
}

export default UserAccount;
